module.exports = __webpack_public_path__ + "static/media/flagRed.2ff9048d.svg";